import React from 'react'
import '../styles/loader.css'

export default () => {
  return (
    <div className="loader-wrapper">
      <div className="loader"></div>
    </div>
  )
}